<div class="carousel">
  <div class="container" #container>
    <ng-content select="[slideContent]"></ng-content>
  </div>

  <div class="action left" [class.visible]="showLeftBtn" (click)="nav(step - 1)">
    <div class="action-btn">
      <app-icon name="chevron_down"></app-icon>
    </div>
  </div>

  <div class="action right" [class.visible]="showRightBtn" (click)="nav(step + 1)">
    <div class="action-btn">
      <app-icon name="chevron_down"></app-icon>
    </div>
  </div>

  <div class="progress__container">
    @for (item of [].constructor(steps); track item; let i = $index) {
      <span [class.progress__bullet__active]="step === i" class="progress__bullet" (click)="nav(i)"></span>
    }
  </div>
</div>
